import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { classNames, useTranslate } from "helpers";
import { FileDropZoneProps } from "./types";
import { ReactSVG } from "react-svg";
import { Loader } from "../../Loader";
import { FilePreviewGrid } from "../FilePreviewGrid";

const FileDropZone: React.FC<FileDropZoneProps> = (props) => {
  const { onChange, onDelete, required, error, files = [], thumbSize = "small" } = props;

  const { t } = useTranslate();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  // If files are present, don't show error (it will clear on next form validation)
  const hasFiles = files && files.length > 0;
  const isError = !!error && !hasFiles;

  // Handle file drop
  const handleDropChange = useCallback(
    (droppedFiles: File[]) => {
      setIsLoading(true);
      onChange(droppedFiles);
      setIsLoading(false);
    },
    [onChange]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDropChange,
  });

  const commonClassName = () => {
    let result = "";
    let defaultStyle = "cursor-pointer ring-1 rounded-sm py-4 flex justify-center items-center mb-3 focus:ring-slate-400 focus:outline-none  ";

    if (isError && required) {
      result = classNames(defaultStyle, "bg-red-50 ring-red-500 text-red-900 placeholder-red-700");
    } else {
      result = classNames(defaultStyle, "bg-slate-50 ring-slate-300");
    }

    return result;
  };

  return (
    <>
      <div className="flex flex-col">
        <div>
          <div
            className={classNames(commonClassName())}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div className="flex items-center justify-center flex-col">
              <div className="mb-4 p-3 h-36">
                {isLoading ? (
                  <Loader isLoading={isLoading ?? false}> </Loader>
                ) : (
                  <ReactSVG src="/media/images/document-move.svg" />
                )}
              </div>
              <div className="font-medium text-sm text-[#475467]">
                <span className="text-blue-500 leading-5">
                  {t("admin.fileupload.description.line1")}
                </span>{" "}
                {t("admin.fileupload.description.line2")}
              </div>
              <p className="font-light text-sm text-[#475467]">
                ( {t("admin.fileupload.maxsize")})
              </p>
            </div>
          </div>
          <FilePreviewGrid
            files={files}
            onDelete={onDelete}
            thumbSize={thumbSize}
            label={t("admin.fileupload.filesloaded")}
          />
        </div>
      </div>
    </>
  );
};

export default FileDropZone;
